import { makeAutoObservable } from 'mobx'
import { IChainConfig, chains } from './chains'

export interface IChilizConfig {
  // config Related to the chain
  chainConfig: IChainConfig
}

export class ChilizConfigProvider {
  private config: IChilizConfig

  constructor (config?: IChilizConfig) {
    if (config != null) {
      this.config = config
    } else {
      const defaultChain = chains.filter(c => c.default)[0]
      const chainConfig = typeof defaultChain !== 'undefined' ? defaultChain : chains[0]
      this.config = { chainConfig }
    }

    makeAutoObservable(this)
  }

  public getConfig = (): IChilizConfig => {
    return this.config
  }

  public setConfig = (config: IChilizConfig): void => {
    this.config = config
  }

  public setConfigForChain = (chainConfig: IChainConfig): void => {
    if (this.config !== undefined) {
      this.config.chainConfig = chainConfig
    }
  }

  public getChainConfig = (): IChainConfig => {
    return this.config.chainConfig
  }
}
